import NoteAddIcon from '@mui/icons-material/NoteAdd';
import SearchIcon from '@mui/icons-material/Search';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

import i18n from 'FRONTEND/utils/i18n';

export const getPatientSupport = () => {
  return {
    title: i18n._('How to find the patient?'),
    text: '',
    paragraphList: [
      {
        title: i18n._('Type at least three letters to search'),
        text: i18n._('In order for the search to give results, you need to supply at least three consecutive characters contained in the patient’s name.'),
        icon: SearchIcon,
      },
      {
        title: i18n._('Be more specific to narrow down the search'),
        text: i18n._('Only a maximum of 15 results are shown at a time. Type more characters to reduce the number of matching patients and find the one you are looking for.'),
        icon: ZoomInIcon,
      },
      {
        title: i18n._('Create a patient if they do not already exist'),
        text: i18n._('If the patient has never been registered, you need to open the creation form by clicking on the "Create a patient" button and fill it up. Then you will be able to finish the last steps of the appointment form.'),
        icon: NoteAddIcon,
      },
    ],
  };
};
